module.exports = __webpack_public_path__ + "08_mustache_grey.583c1736.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/08_mustache_grey.png
// module id = 98+q
// module chunks = 0